import { useSelector } from 'react-redux';
import { useTasksCount } from '../Tasks/hooks/useTasksCount';

export const useNotificationCount = () => {
  const totalReminders = useSelector((state) => state.alerts.totalReminders);
  const totalTasks = useTasksCount();

  return totalReminders + totalTasks;
};
